export interface AuthCredentials {
    username: string;
    password: string;
}

export const getAuthCredentials = (): AuthCredentials => {
    const username = process.env.REACT_APP_KHEETIGADI_USERNAME;
    const password = process.env.REACT_APP_KHEETIGADI_PASS_KEY;

    if (!username || !password) {
        throw new Error('API credentials are missing.');
    }

    return { username, password };
};